<ng-container *ngIf="!!get">
    <div class="col-xs-12 sp-0">
        <tt-card class="col-xs-12 sp-5 col-md-4">
            <tt-select
                ttLabel="orderline_keyno_pick_to"
                [(ttModel)]="get.orderline_keyno_pick_to"
                (ttModelChange)="onChange('orderline_keyno_pick_to')"
                [ttData]="orderlines"
                ttDataId="orderline_keyno"
                ttDataName="orderline_name"
            ></tt-select>
            <tt-search
                ttLabel="stockbatch_search"
                [(ttModel)]="get.stockbatch_search"
                (ttModelChange)="$event === '' ? onStockBatchSelected() : null"
                [ttSearch]="searchStockBatches"
                (ttOnSelected)="onStockBatchSelected($event)"
            ></tt-search>
            <tt-input ttLabel="prod_id" [ttModel]="get.prod_id" ttReadonly></tt-input>
            <tt-search
                ttLabel="prod_name"
                [(ttModel)]="get.prod_name"
                (ttModelChange)="$event === '' ? onProductSelected() : null"
                [ttSearch]="searchProducts"
                (ttOnSelected)="onProductSelected($event)"
            ></tt-search>
            <ng-container *ngIf="get.show_button_save === '1'">
                <tt-input-number ttLabel="input_quantity" [(ttModel)]="get.input_quantity" (ttOnBlur)="updateQuantityStockUnits()" ttTextAlign="right" ttDecimals="2"></tt-input-number>
                <tt-select
                    ttLabel="input_unit"
                    [(ttModel)]="get.input_unit_no"
                    (ttModelChange)="updateQuantityStockUnits()"
                    [ttData]="productUnits"
                    ttDataId="unit_no"
                    ttDataName="shortname"
                ></tt-select>
                <tt-input-number ttLabel="input_quantity_stock_units" [(ttModel)]="get.input_quantity_stock_units" ttTextAlign="right" ttDecimals="2" ttReadonly></tt-input-number>
                <tt-button-save ttText="orderpicknew_save" (ttClick)="save()"></tt-button-save>
                <tt-button ttText="orderpicknew_distribute" ttIcon="fas fa-sync-alt" (ttClick)="distribute()" [ttLoading]="distributing"></tt-button>
            </ng-container>
        </tt-card>
        <tt-card class="col-xs-12 sp-5 col-md-4">
            <tt-input *ngIf="get.show_labour_no === '0'" ttLabel="labour_name" [ttModel]="get.labour_name" ttReadonly></tt-input>
            <ng-container *ngIf="get.show_labour_no === '1'">
                <tt-input-number ttRememberId="w_orderpicknew.labour_no" ttLabel="labour_no" [(ttModel)]="get.labour_no" (ttModelChange)="onChange('labour_no')" ttTextAlign="right"></tt-input-number>
                <tt-select
                    ttRememberId="w_orderpicknew.labour_no"
                    ttLabel="labour_name"
                    [(ttModel)]="get.labour_no"
                    (ttModelChange)="onChange('labour_no')"
                    [ttData]="labourers"
                    ttDataId="labour_no"
                    ttDataName="labour_name"
                ></tt-select>
            </ng-container>
            <tt-input-number ttLabel="order_order_no" [ttModel]="get.order_order_no" ttTextAlign="right" ttReadonly></tt-input-number>
            <tt-input-number ttLabel="quantity_stock_need" [(ttModel)]="get.quantity_stock_need" ttTextAlign="right" ttDecimals="2" ttReadonly></tt-input-number>
            <tt-input-number ttLabel="quantity_stock_picked_before" [(ttModel)]="get.quantity_stock_picked_before" ttTextAlign="right" ttDecimals="2" ttReadonly></tt-input-number>
            <tt-input-number
                ttLabel="quantity_stock_rest"
                [(ttModel)]="get.quantity_stock_rest"
                ttTextAlign="right"
                ttDecimals="2"
                ttReadonly
                [ttInvalid]="+get.quantity_stock_rest < 0"
            ></tt-input-number>
        </tt-card>
        <tt-card class="col-xs-12 sp-5 col-md-4">
            <tt-textarea ttLabel="note" [(ttModel)]="get.note"></tt-textarea>
            <tt-input-number ttLabel="stock_keyno" [ttModel]="get.stock_keyno" ttTextAlign="right" ttReadonly></tt-input-number>
            <tt-input-number ttLabel="stockbatch_keyno" [(ttModel)]="get.stockbatch_keyno" ttTextAlign="right" ttReadonly>
                <ng-container buttons>
                    <tt-form-field-button
                        ttId="erase"
                        ttIcon="fas fa-eraser"
                        ttType="danger"
                        (ttClick)="get.stockbatch_keyno = '0'; readStockBatchesGrid(); readPickedBeforeGrid()"
                    ></tt-form-field-button>
                </ng-container>
            </tt-input-number>
            <tt-input [ttModel]="get.show_button_save" ttReadonly></tt-input>
        </tt-card>
    </div>
    <tt-tabs #tabs>
        <tt-tab ttId="PICKNOW" ttLabel="gb_orderpicknew_picknow"></tt-tab>
        <tt-tab ttId="PICKEDBEFORE" ttLabel="gb_orderpicknew_pickedbefore"></tt-tab>
    </tt-tabs>
    <tt-grid [hidden]="tabs.ttSelectedId !== 'PICKNOW'" *ngIf="!!stockBatchesGrid" class="flex-1" [(ttOptions)]="stockBatchesGrid" style="min-height: 300px"></tt-grid>
    <tt-grid [hidden]="tabs.ttSelectedId !== 'PICKEDBEFORE'" *ngIf="!!pickedBeforeGrid" class="flex-1" [(ttOptions)]="pickedBeforeGrid" style="min-height: 300px"></tt-grid>
</ng-container>
